<template>
    <div>
        <el-table
            :data="tableData"
            border
            height="500"
            size="small"
            style="width: 100%">
            <el-table-column prop="carrier" label="承运人姓名" align="center" width="100"></el-table-column>
            <el-table-column prop="satisfyPoint" label="运输效率评分" align="center" width="120"></el-table-column>
            <el-table-column prop="safePoint" label="运输安全评分" align="center" width="120"></el-table-column>
            <el-table-column prop="qualityPoint" label="服务质量评分" align="center" width="120"></el-table-column>
            <el-table-column prop="satisfyPoint" label="托运人满意度评分" align="center" width="140"></el-table-column>
            <el-table-column prop="comprehensivePoint" label="综合评分" align="center" width="100"></el-table-column>
            <el-table-column prop="examineStatus" label="退出状态" align="center" width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.examineStatus == 0">未退出</span>
                    <span v-else>已退出</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            style="text-align: right; height: 50px;margin-top: 10px;"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="categoryList.currentPage"
            :page-sizes="pageSizes"
            :page-size="categoryList.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalPage">
        </el-pagination>
    </div>
</template>

<script>
import { getCarrierList } from '@/api/api'

export default {
    name: 'carrierListModal',
    data () {
        return {
            loading: true,
            defaultActive: null,
            categoryList: [],
            newsList: [],
            currentPage: 1,
            pageSize: 10,
            totalPage: 1,
            pageSizes: [10, 20, 30],
            menuActiveKey: null,
            tableData: []
        }
    },
    created () {
        this.loadData()
    },
    methods: {
        handleSizeChange (val) {
            this.pageSize = val
            this.loadData()
        },
        handleCurrentChange (val) {
            this.currentPage = val
            this.loadData()
        },
        loadData () {
            this.loading = true
            let params = {
                pageNo: this.currentPage,
                pageSize: this.pageSize
            }
            getCarrierList(params).then(res => {
                if (res.data.success) {
                    let result = res.data.result
                    this.tableData = result.records
                    this.currentPage = result.current
                    this.pageSize = result.size
                    this.totalPage = result.total
                }
            })
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/appraise/modules/carrierListModal.vue